import React from "react";
import { spotlight_mobile } from "@/generated";
import Image from "next/image";

interface LoaderProps {
  onClick?: () => void;
  spotlight: spotlight_mobile;
}

const AnnouncementBanner: React.FC<LoaderProps> = (props) => {
  const { onClick, spotlight } = props;

  return (
    <div className="mx-2">
      {spotlight.content_type === "text" ? (
        <div
          className="w-full relative  flex items-center justify-center bg-white border-2 rounded-xl border-ng-font-3  cursor-pointer mb-2"
          onClick={onClick}
        >
          <p className="text-sm font-bold text-ng-font-3 py-4 pl-2">
            {spotlight.banner_text}
          </p>
        </div>
      ) : (
        <div
          className="w-full relative  flex items-center justify-centercursor-pointer mb-2"
          onClick={onClick}
        >
          <Image
            src={spotlight.picture_url}
            alt="Announcement Banner"
            width={360}
            height={100}
            className="w-full h-auto"
          />
        </div>
      )}
    </div>
  );
};

export default AnnouncementBanner;
